import React, { useRef, useState } from 'react';
import { Popover } from 'react-tiny-popover';

import { ArrowIcon } from '../svg';

import styless from './styles.module.scss';

export default function Dropdown({ children }: { children?: React.ReactNode }) {
  const [visible, setVisible] = useState(false);
  const clickMeButtonRef = useRef<HTMLButtonElement>(null) as any;

  const hide = () => setVisible(false);

  function handleDropdownClick(e: any) {
    e.preventDefault();
    setVisible(true);
  }

  const containerStyle: any = {
    display: visible ? 'flex' : 'none',
    zIndex: 999,
    position: 'fixed',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    borderRadius: '4px',
    boxShadow: '-12px 12px 36px 0px rgba(0, 0, 0, 0.40)',
    width: '479px',
    padding: '32px',
    alignItems: 'flex-start',
  };

  return (
    <Popover
      isOpen={visible}
      positions={['bottom', 'top', 'right', 'left']} // preferred positions by priority
      content={
        <div style={containerStyle}>
          <button className={styless.close} onClick={hide} type="button">
              close
          </button>
          {children}
        </div>
      }
      ref={clickMeButtonRef}
      onClickOutside={hide}
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" className={styless.link} onClick={handleDropdownClick}>
          View help guides <ArrowIcon height={8} width={8} />
      </a>
    </Popover>
  );
}
